import TrendsPage from './TrendsPage';

import './trends.scss';

export default TrendsPage;